// Module
var code = ` <template> <div class="page-rfq-add-rightship-inspection"> <compose view-model.bind="getViewModel()" model.bind="model" view-model.ref="addRightshipInspectionVM"></compose> </div> </template>`;
// Exports
module.exports = code;